export function getDiscountLineLabel(bookingData) {
  const amount = Number(bookingData?.appliedDiscount) || 0;
  if (amount <= 0) return 'Rabatt';

  const type = (bookingData?.discountTypeApplied || '').toString().toUpperCase();
  const configRaw = bookingData?.discountValueApplied;
  const configVal =
    configRaw != null && configRaw !== '' && !Number.isNaN(Number(configRaw))
      ? Number(configRaw)
      : null;
  const minH = bookingData?.discountMinHoursApplied;
  const abHours =
    minH != null && minH > 0 ? ` ab ${minH} Stunden` : '';

  if (configVal != null) {
    if (type === 'PERCENTAGE') {
      return `Rabatt (${configVal}%)${abHours ? abHours : ''}`;
    }
    return `Rabatt (${configVal}€ pro Stunde ${abHours ? abHours : ''})`;
  }

  if (type === 'PERCENTAGE') {
    const base = Number(bookingData?.baseStudioPrice) || 0;
    const surcharge = Number(bookingData?.appliedSurcharge) || 0;
    const discountBase = base + surcharge;
    if (discountBase > 0) {
      const pct = Math.round((amount / discountBase) * 100);
      return `Rabatt (${pct}%)${abHours ? abHours : ''}`;
    }
  }

  return `Rabatt${abHours}`;
}
